import { Component } from '@angular/core';

@Component({
  selector: 'xp-settings',
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss'
})
export class SettingsComponent {

}
